import React from "react";

export function AllMailPage() {

 return <>
  <div style={{
      margin: '1rem',
      verticalAlign: 'middle',
      textAlign: 'center',
      paddingTop: '30%',
      fontSize: '3rem',
      height: '100%'
  }}>
      전체메일
  </div> 

</>;
}
